import { Component, Input, OnInit } from '@angular/core';

import { Customer, CustomerProfileDetails } from '../../../../../../../../models/customer';
import { MailchimpGroup, MailchimpGroupCategory } from '../../../../../../../../models/organization-config';
import { CallbackResult, CallbackResultStatus } from '../../../../../../../../utils';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../../../../../../../../services/customer/customer.service';
import { MailchimpGroupCategoryType } from '../../../../../../../../models/organization-config-enums';


@Component({
  selector: 'app-edit-customer-mailchimp-groups-modal',
  templateUrl: './edit-customer-mailchimp-groups-modal.component.html',
  styleUrls: ['./edit-customer-mailchimp-groups-modal.component.css']
})
export class EditCustomerMailchimpGroupsModalComponent implements OnInit {
  @Input() customer: Customer;
  @Input() customerProfileDetails: CustomerProfileDetails;
  @Input() orgMailchimpGroupCategories: MailchimpGroupCategory[];
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public selectedGroupIds: number[];

  public loadingSubmit = false;
  public errorMessage = '';
  public serverError: number = null;

  public MailchimpGroupCategoryType = MailchimpGroupCategoryType;

  constructor(
    public activeModal: NgbActiveModal,
    public customerService: CustomerService
  ) {}

  ngOnInit() {
    this.selectedGroupIds = [...this.customerProfileDetails.mailchimp_group_ids];
  }

  public toggleGroupInclusive(groupId: number) {
    if (this.selectedGroupIds.includes(groupId)) {
      this.selectedGroupIds.splice(this.selectedGroupIds.indexOf(groupId), 1);
    } else {
      this.selectedGroupIds.push(groupId);
    }
  }

  public selectGroupExclusive(groupId: number, groupCategory: MailchimpGroupCategory) {
    for (const thisGroup of groupCategory.groups) {
      if (this.selectedGroupIds.includes(thisGroup.id)) {
        this.selectedGroupIds.splice(this.selectedGroupIds.indexOf(thisGroup.id), 1);
      }
    }

    // @ts-ignore
    if (![null, 'null'].includes(groupId)) {
      this.selectedGroupIds.push(groupId);
    }
  }

  public noneSelectedForGroupCategory(groupCategory: MailchimpGroupCategory): boolean {
    for (const thisGroup of groupCategory.groups) {
      if (this.selectedGroupIds.includes(thisGroup.id)) {
        return false;
      }
    }

    return true;
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.customerService
      .setCustomerMailchimpGroups(this.customer.id, this.selectedGroupIds)
      .then(() => {
        this.savedCallback({
          text: 'Mailchimp groups updated successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to edit this customer\'s Mailchimp groups.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }
}
